import { render, staticRenderFns } from "./addressInfo.vue?vue&type=template&id=1e945ccd&scoped=true&"
import script from "./addressInfo.vue?vue&type=script&lang=js&"
export * from "./addressInfo.vue?vue&type=script&lang=js&"
import style0 from "./addressInfo.vue?vue&type=style&index=0&id=1e945ccd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e945ccd",
  null
  
)

export default component.exports